import React from "react";
import {
  Link,
  Redirect,
  Route,
  Switch,
  useLocation,
  useRouteMatch,
} from "react-router-dom";

import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";

import CashPage from "./CashPage/CashPage";
import ItemsPage from "./ItemsPage/ItemsPage";
import UsersPage from "./UsersPage/UsersPage";

import "./Tellers.sass";

export default function Tellers({ currentUser, party, event, rfidSettings }) {
  const { url, isExact } = useRouteMatch();
  const { pathname } = useLocation();
  const usersPath = `${url}/users`;
  const cashPath = `${url}/cash`;
  const itemsPath = `${url}/items`;

  const partyLabel =
    party?.name ?? (party?.pk != null ? `Party #${party.pk}` : null);

  return (
    <Row className="Tellers">
      {isExact && <Redirect to={usersPath} />}

      {partyLabel != null && (
        <Col xs={12} className="Tellers__party-col">
          <div className="Tellers__party-banner">
            <span className="Tellers__party-label">Assigned party</span>
            <p className="Tellers__party-name">{partyLabel}</p>
          </div>
        </Col>
      )}

      <Col className="Tellers__nav-col" xs={12}>
        <Nav justify variant="pills" defaultActiveKey="users">
          <Nav.Item>
            <Nav.Link
              eventKey="users"
              active={usersPath === pathname}
              as={Link}
              to={usersPath}
            >
              Customers
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link
              eventKey="cash"
              active={pathname.startsWith(cashPath)}
              as={Link}
              to={cashPath}
            >
              Cash
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link
              eventKey="items"
              active={pathname === itemsPath}
              as={Link}
              to={itemsPath}
            >
              Items
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Col>
      <Col className="Tellers__content-col" xs={12}>
        <Switch>
          <Route exact path={usersPath}>
            <UsersPage
              party={party}
              event={event}
              currentUser={currentUser}
              rfidSettings={rfidSettings}
              canAddNewCustomer={false}
            />
          </Route>

          <Route path={cashPath}>
            <CashPage currentUser={currentUser} />
          </Route>

          <Route path={itemsPath}>
            <ItemsPage />
          </Route>
        </Switch>
      </Col>
    </Row>
  );
}
